export default "__VITE_ASSET__CfrT2RaE__"